<template>
  <div
    :id="data.Id"
    :data-elementindex="elementIndex"
    :data-translateX="data.X"
    :data-translateY="data.Y"
    :data-rotate="data.RotateDegree"
    :style="getGroupStyle"
    :class="getClass"
    data-type="group"
  >
    <component
      v-for="child in data.children"
      :is="child.type + '-object'"
      :key="`${child.Id}-${child.StrokeColor || ''}-${(child.SvgProperty && child.SvgProperty.StrokeColor) || ''}`"
      :data="child"
      :object-props="child"
      :element-index="-1"
      :is-group-child="true"
      :scale="scale"
      :is-fake-rendering="isFakeRendering"
      :is-animation-in-progress="isAnimationInProgress"
      :display-controls="!!child.isSelected"
    />
  </div>
</template>

<script>
import {
  Text, Path, Image, Video, Table
} from '@/components/CanvasShapes/index';

export default {
  name:       'GroupComponent',
  components: {
    'text-object':  Text,
    'shape-object': Path,
    'image-object': Image,
    'video-object': Video,
    'table-object': Table,
  },
  props: {
    data:            { type: Object, required: true },
    elementIndex:    { type: Number, default: -1 },
    scale:           { type: Number, default: 1 },
    isFakeRendering:       { type: Boolean, default: false },
    isAnimationInProgress: { type: Boolean, default: false },
  },
  computed: {
    getGroupStyle() {
      const { PdfSortOrder, IsVisible } = this.data;
      return {
        position:      'absolute',
        left:          '0px',
        top:           '0px',
        width:         '0px',
        height:        '0px',
        overflow:      'visible',
        transform:       'none',
        transformOrigin: 'top left',
        zIndex:        PdfSortOrder,
        visibility:    IsVisible ? 'visible' : 'hidden',
        pointerEvents: 'none',
      };
    },
    getClass() {
      return 'position-absolute target group-object';
    },
  },
};
</script>
